import styled from 'styled-components';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import Container from '../styled/Container';
import {
  MozartIcon,
  MozartImage,
  MozartNavigationItem,
} from '@pgforsta/mozart_ui';
import { logout } from '../../api/client';
import { useAuth } from '../../context/auth';

const Wrapper = styled.div`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  background-color: #ffffff;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
`;

const InnerWrapper = styled.div`
  padding: 15px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Navigation = styled.div``;

const Logo = styled.img`
  height: 30px;
`;

const Actions = styled.div`
  display: inline-flex;
`;

const iconStyle = {
  height: '20px',
  marginLeft: '6px',
  padding: '5px 0',
  fontSize: '16px',
  fontWeight: 600,
  border: '1px solid #d9d5f9',
};

const imageStyle = {
  marginLeft: '5px',
  width: '30px',
  height: '30px',
};

const avatarIconStyle = {
  ...iconStyle,
  fontSize: '20px',
};

const Header = () => {
  const { user } = useAuth();

  const goToToolsBha = () => {
    window.location.href = process.env.REACT_APP_TOOLS_BHA_BASE_URL;
  };

  const getProfilePicture = () =>
    user?.profilePictureUrl ? (
      <MozartImage
        style={imageStyle}
        src={user?.profilePictureUrl}
        variant="overlay-circle"
      />
    ) : (
      <MozartIcon
        style={avatarIconStyle}
        data={<span className="icon-Avatar" />}
      />
    );

  return (
    <Wrapper>
      <Container>
        <InnerWrapper>
          <Navigation>
            <Logo alt="Logo" src="/logo.png" />
            <Breadcrumbs />
          </Navigation>
          <Actions>
            <MozartIcon
              style={iconStyle}
              data={<span className="icon-Home" onClick={goToToolsBha} />}
            />
            <MozartNavigationItem
              data={getProfilePicture()}
              icon
              items={[
                {
                  itemData: 'Logout',
                  onClick: logout,
                },
              ]}
            />
          </Actions>
        </InnerWrapper>
      </Container>
    </Wrapper>
  );
};

export default Header;
